import { getFullDate } from "./dateHelpers";
import React from "react";

export function getItemExpiredDate(item) {
  return (
    <>
      <span>Expired: </span>
      <span>{getFullDate(item.dateExpiring)}</span>
    </>
  );
}

export function getJobSubmittedDate(job) {
  return (
    <>
      <span>Submitted: </span>
      <span>{getFullDate(job.dateCreated)}</span>
    </>
  );
}

export function getItemPublishedDate(job) {
  return (
    <>
      <span>Published: </span>
      <span>{getFullDate(job.datePublished)}</span>
    </>
  );
}

export function getDraftJobSavedDate(job) {
  return (
    <>
      <span>Saved: </span>
      <span>{getFullDate(job.dateCreated)}</span>
    </>
  );
}

export function getPromotionPurchasedDate(promotion) {
  return (
    <>
      <span>Submitted: </span>
      <span>{getFullDate(promotion.datePurchased)}</span>
    </>
  );
}
